import React from "react";
import { createRoot } from "react-dom/client";
import { GlobalStyle } from "./constants/global-style";

import App from "./App";

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);
root.render(
  <React.StrictMode>
    <GlobalStyle />
    <App />
  </React.StrictMode>,
);
